
export type ColorName = '--error'|'--on-surface'|'--accent'|'--accent-light'

export const colors = {
  '--error': 'hsl(0 85% 46%)',
  '--on-surface': 'hsl(125 20% 90%)',
  '--accent': 'hsl(125 93% 65.1%)',
  '--accent-light': "hsl(125 34.41% 24.8%)" 
}
